<template>
    <div :style="{ overflowY: showExplanation ? 'scroll' : '' }" style="font-weight: 500; position: relative; overflow-y: scroll;">
        <div style="position: relative;">
            <div style="position: absolute; width: 100%;">
                <Transition name="fade">
                    <div v-if="fade1 && !showPosition" style="position: absolute; top: -15px; width: 100%; transform: translateX(-50%); left: 50%; margin-top: 70px; margin-bottom: 28px; text-align:center; line-height: 28px; font-size:32px; font-weight: 700;">포지션 찾기<br><span style="display: inline-block; margin-top: 4px; font-size: 16px; font-weight: 500; line-height: 24px;">사커하우가 찾은 회원님의 축구 포지션입니다.</span></div>
                </Transition>
                <Transition name="fade">
                    <div v-if="fade2 && positionsArr.length > 0" style="position: relative;">
                        <div style="height:30px;"></div>
                        <div class="temp_name2" v-show="isShowCopyPicture" ref="fake_img" style="position: absolute; transition: all 1s;" :style="{
                            left: copy_picture_left + 'px',
                            top: (copy_picture_top - picture_top_gap) + 'px',
                            width: copy_picture_width + 'px',
                            transform: 'scaleX(' + copy_picture_scale_x + ')'
                        }">
                            <img :src="img_path" style="width:100%;">
                        </div>

                        <div v-show="isShowPositionPictures" ref="image_wrap" :class="positionsArr.length > 1 ? 'many_image' : 'one_image'" style="overflow-y: hidden; height: 360px; top: 124px;  width: 100%;">
                            <div :data-num='i' style="position: relative; opacity: 1; top: 130px; height: 160px; transition: opacity 1s" ref="images" v-for="each, i in positionsArr" :key="i" :style="{ visibility: curSelectedPictureIndex === i ? 'hidden' : '', opacity: positionPictureOpacity }">
                                <img style=" width: 160px; " @click="showPositionResult(each.desc, i, result[each.desc].images[0])" :src="result[each.desc].images[0]">
                                <div style="text-align: center; margin-top: 8px; font-weight: 500; font-size: 14px">{{ result[each.desc].explanation[0] }}</div>
                            </div>
                        </div>
                    </div>
                </Transition>
                <Transition name=" fade">
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); width: 100%; top: 402px;" v-if="fade3 && !showPosition">
                        <div style="text-align: center; font-size: 12px; color: #606060;">그림을 눌러 내용을 확인할 수 있습니다.</div>
                        <!-- <div :class="positionsArr.length === 1 ? 'one_result' : 'else_result'">
                            <div v-for="each, i in positionsArr" :key="i + 'two'">
                                <span v-if="i !== 0">/&nbsp;</span>{{ result[each.desc].explanation[0] }}
                            </div>
                        </div>
                        <div @click="showPositionResultOneResult(positionsArr[0].desc, 0, result[positionsArr[0].desc].images[0])" class="show_position">{{ positionsArr.length === 1 ? '포지션 결과 보기' : '그림을 눌러 결과 확인' }}</div> -->
                    </div>
                </Transition>
            </div>
        </div>
        <!-- <div style="font-weight:900; text-align:center; font-size:25px; margin-top:20px; color:#fe6100">{{ result[position].explanation[1] }}</div> -->
        <!-- <template v-if="index === 0 && showPosition">
            <div style="text-align:center; display:flex; align-items: center; justify-content: center; position: absolute; top: 0;" @click="share">
                <div class="circle">
                    <img :src="require('@/assets/img/share_position.png')" style="width: 17px;">
                </div>
            </div>
        </template> -->
        <Transition name="fade">
            <div v-if="showPosition" style="padding:20px; padding-bottom: 0;">
                <div v-if="showExplanation" style="display:flex; align-items: center; border-bottom: 1px solid #f5f5f5; width: calc(100% + 40px); margin-left: -20px; padding: 20px; padding-top: 0;">
                    <div style="font-size: 24px; font-weight: 700;">포지션 설명</div>
                    <div style="flex: 1;"></div>
                    <div style="display: flex;">
                        <div @click="() => { $GlobalStore.closeLastModal() }">
                            <div class="circle"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
                        </div>
                    </div>
                </div>
                <div :style="{ marginTop: showExplanation ? '40px' : '' }" class="temp_name1" style="position: relative; display: flex; justify-content: center;  margin-bottom: 40px;">
                    <img v-if="initPosition" style="transition: 1s all; width: 222px; opacity: 1;" :src="img_path">
                    <img v-else :style="{ opacity: showExplanation ? '1' : '0' }" style="transition: 1s all; width: 222px; opacity: 0;" :src="img_path">
                </div>
                <div style="margin-top: 20px;">
                    <div style="border-bottom: 1px solid #d9d9d9; padding-bottom: 30px;">
                        <div style="font-size:16px;">포지션 유형</div>
                        <div style="display: flex; margin-top: 16px; justify-content: space-between; align-items: end;">
                            <div>
                                <div style="font-size:20px; font-weight:700;">{{ result[position].explanation[2] }}</div>
                                <!-- 관련정보 들어가야됨 밑에 -->
                                <div style="margin-top: 10px; font-weight: 400; font-size: 12px; color: #606060;">Striker / Centre-forward</div>
                            </div>
                            <!-- <div>
                                <div @click="share" class="shared">친구에게 자랑하기</div>
                            </div> -->
                        </div>
                    </div>

                    <div style="margin: 30px 0; font-weight: 500; border-bottom: 1px solid #d9d9d9; padding-bottom: 30px;">
                        <div style="margin-bottom: 10px;">코멘트</div>
                        <div v-html="result[position].explanation[3]" style="line-height:23px; font-size: 14px;"></div>
                        <div style="margin-top:8px; color: #808080; font-size: 12px;">{{ result[position].explanation[4] }}</div>
                    </div>

                    <!-- <div style="width: calc(100% + 40px); margin-left: -20px; height: 10px; background-color: #f5f5f5;"></div> -->

                    <div style="border-bottom: 1px solid #d9d9d9; padding-bottom: 30px;">
                        <div class="subTitle">{{ result[position].explanation[5] }}</div>
                        <div class="explanation">{{ result[position].explanation[6] }}</div>
                        <div class="explanation">{{ result[position].explanation[7] }}</div>
                    </div>

                    <!-- <div style=" margin-top:40px; margin-bottom: 50px;">
                        <div style="font-size: 20px; margin-bottom: 16px;">{{ result[position].explanation[9] }}</div>
                        <div v-html="result[position].explanation[8]" style="line-height:23px; font-weight: 400; font-size: 14px;"></div>
                        <div style="width: 250px; margin: 0 auto; color: #ffffff; margin-top: 30px; font-size: 14px; height: 40px; line-height: 40px; text-align: center; border-radius: 22.5px; background: linear-gradient(60deg, #FF8C21 13.4%, #FAC74D 86.6%);">포지션 맞춤 가이드 자세히 보기</div>
                    </div> -->

                    <!-- <div style="width: calc(100% + 40px); margin-left: -20px; height: 10px; background-color: #f5f5f5;"></div> -->
                </div>

                <div style="padding-bottom:40px;">
                    <div style="margin-top: 20px;">
                        <div style="margin-bottom: 8px; font-size: 20px;">월드클래스 {{ result[position].explanation[0] }} 선수</div>
                        <div style="line-height: 28px; font-weight: 500;">회원님의 포지션에서 뛰는 대표적인 선수들입니다</div>
                    </div>
                    <div style="display:flex; justify-items: center; gap: 50px; margin-top: 16px;">
                        <div style="display:flex; text-align:center; overflow-x: scroll; overflow-y: hidden; margin: 0 -20px; padding: 0 20px; gap: 12px; border-bottom: 1px solid #ededed; padding-bottom: 32px;">
                            <div style="">
                                <img :src="result[position].images[0]" style="width:150px;">
                                <div class="player_name">{{ result[position].names[0] }}</div>
                            </div>
                            <div style="">
                                <img :src="result[position].images[2]" style="width:150px;">
                                <div class="player_name">{{ result[position].names[2] }}</div>
                            </div>
                            <div style="">
                                <img :src="result[position].images[1]" style="width:150px;">
                                <div class="player_name">{{ result[position].names[1] }}</div>
                            </div>
                            <div>
                                <img :src="result[position].images[3]" style="width:150px;">
                                <div class="player_name">{{ result[position].names[3] }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 0px; border-bottom: 1px solid #ededed; padding-bottom: 32px;" v-if="!initPosition">
                    <div class="explanation" v-html="result[position].explanation[10]"></div>
                    <div class="explanation">{{ result[position].explanation[11] }}</div>
                    <!-- <div @click="retryFindPosition" style="height: 50px; border-radius: 6px; margin-top: 43px; margin-bottom: 60px; color: #fff; background-color: #101014; line-height: 50px; text-align: center;">포지션 찾기 다시하기</div> -->
                </div>
                <!-- <div style="width: calc(100% + 40px); margin-left: -20px; height: 10px; background-color: #f5f5f5;"></div> -->
                <div style="margin-top: 32px; padding-bottom: 30px;">
                    <div style="font-size: 20px; font-weight: 500;">프로들의 추천</div>
                    <div style="margin-top: 8px;">
                        <img style="width: 100%;" :src="require('@/assets/img/pro_banner.png')" alt="">
                    </div>
                    <div style="display: flex; margin-top: 12px; justify-content: space-between;">
                        <div style="font-size: 12px;font-weight: 500;line-height: 20px;">나의 축구 능력치를 분석하는 포지션 찾기!<br>훈련 방법과 전문적인 피드백을 제공합니다.</div>
                        <div @click="findPositionPro" style="border-radius: 22.5px; width: 93px; height: 36px; background-color: #f5f5f5; line-height: 36px; font-size: 12px; font-weight: 500; text-align: center; color: var(--color-main);">바로가기</div>
                    </div>
                </div>
                <!-- <div style="margin-top: 60px; padding-bottom: 40px;">
                    <div style="font-weight: 700; font-size: 20px; line-height: 28px;">포지션을 찾았다면?<br>아무데서나 뛰지 마세요</div>
                    <div style="margin-top: 16px; line-height: 27px;">다양한 프로 선수, 코치, 감독들을 통해 검증한<br>진짜 믿음직한 포지션 가이드를 제공할게요!<br>이런 놀라운 데이터는 오직 사커하우에만 있죠.</div>
                    <div style="margin-top: 10px; font-weight: 400; font-size: 12px; line-height: 17px;">200명의 프로팀 선수들이<br>포지션 찾기 프로버전을 사용했어요.</div>
                    <div style="color: #ffffff; margin-top: 30px; height: 50px; line-height: 50px; text-align: center; border-radius: 22.5px; background: linear-gradient(60deg, #FF8C21 13.4%, #FAC74D 86.6%);">포지션 맞춤 가이드 자세히 보기</div>
                </div> -->
            </div>
        </Transition>

    </div>
</template>

<script>
import { TOAST_TYPE } from '../../Constants';

export default {
    name: "MyPositionResult",
    props: {
        name: String,
        // position: String,
        index: Number,
        fade1: {
            type: Boolean,
            default: false,
        },
        fade2: {
            type: Boolean,
            default: false,
        },
        fade3: {
            type: Boolean,
            default: false,
        },
        showResult: {
            type: Function,
            default: () => { }
        },
        positionsArr: {
            type: Array,
            default: () => { }
        },
        showPosition: {
            type: Boolean,
            default: () => { }
        },
        signalCloseDetail: {
            type: Boolean,
            default: false
        },
        initPosition: {
            type: String,
            default: ''
        },
        showExplanation: {
            type: Boolean,
            default: false
        },
        originallyPosition: {
            type: String,
            default: ''
        },
        confirmProfilePosition: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            position: '',
            isShowProModal: false,
            img_path: null,
            left: 0,
            result: {
                CF: {
                    explanation: [
                        '중앙 공격수',
                        'CENTER FOWARD',
                        '중앙 공격수 (CF)',
                        '스트라이커의 역할은 이제 더 이상 골을<br>넣는 것에만 한정지을 수 없다.',
                        '조나단 윌슨',
                        '',
                        '재빠르며 도전적이고, 좋은 피지컬과 개인기량을 갖춘 중앙 공격수 (CF)는 팀을 승리로 이끌어내는 상당히 중요한 역할을 해요! ',
                        '현대 축구에서 중앙 공격수는 빠르고, 훌륭한 마무리 능력을 가지고 있어야 하며, 팀원들과 효과적인 콤비네이션 플레이를 할 수 있도록 기회를 잘 옅봐야 하죠. 최근에는 상대 수비수에게 압력을 가함으로써 수비를 지원하고 상대편의 빌드업 플레이를 저지하여 또 다른 기회를 창출하기도 해요.',
                        '골 냄새를 맡고 공을 호시탐탐 노리고 있는 거죠 :) 그냥 골을 주워 먹는 역할이라 생각할 수 있지만, 어떻게 하면 현재의 흐름에서 골을 넣을 수 있을지를 계속 생각하고, 플레이를 만들며 마무리를 지어야 하기에 생각보다 지능적으로 플레이를 해야 하죠.',
                        '동물적인 감각과 순발력!',
                        '또한 볼 득점뿐만 아니라 빌드업 되는 흐름과 상대 진영의 공간들을 잘 파악하고, 후방에 있는 선수들에게 볼을 효율적으로 패스하여 득점을 만들도록 유도하는 플레이 도 만들 수 있어야 해요.',
                        '매사에 빠르고 정확한 결정을 내릴줄 알며, 좋은 피지컬과 개인기량을 갖추어 기회가 되는 순간을 동물적인 감각으로 파악하여 마무리 지을 줄 아는 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 중앙 공격수입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_cf_로베르트 레반도프스키.png'),
                        require('@/assets/myposition_cf_루이스 수아레즈.png'),
                        require('@/assets/myposition_cf_에딘손 카바니.png'),
                        require('@/assets/myposition_cf_엘링 홀란드.png'),
                    ],
                    names: [
                        '로베르트 레반도프스키', '루이스 수아레즈', '에딘손 카바니', '엘링 홀란드'
                    ]
                },
                SS: {
                    explanation: [
                        '세컨드 스트라이커',
                        'SECOND STRIKER',
                        '세컨드 스트라이커 (SS)',
                        '그는 항상 스트라이커였지만 스트라이커는 아니었다. <br>미드필더이지만 미드필더도 아니었다.',
                        '아르센 벵거',
                        '',
                        '날카로우면서도, 폭발적이고, 뛰어난 개인기량을 통해 압박을 벗어나 공격에 가담하는 세컨컨드 스트라이커 (SS)는 중앙 공격수를 도와 득점 찬스를 만들어내거나 득점을 직접 올려 승리를 이끌어내는 역할을 해요.',
                        '현대 축구에서 세컨드 스트라이커는 빠르고 효과적으로 패스를 연계할 수 있도록 기본적인 기량이 뛰어나야 하며, 공간에 대한 지각능력과 넓은 시야각을 가지고 있어야 하죠. 상황에 따라서 직접 득점을 할 수 있도록 득점 능력까지도 좋아야하는 상당한 난이도를 가진 포지션이예요.',
                        '득점’이라는 요리를 만드는 쉐프라고 할 수 있어요. 공격형 미드필더와 차이가 없다고 생각할 수 있지만, 스트라이커로서의 역할과 공격형 미드필더로서의 역할을 같이 소화하며 활약하는만큼 공격력이 압도적으로 높아야 하는 역할이죠.',
                        '노련미 넘치는 뇌지컬과 피지컬',
                        '공간 창출, 흐름 통제, 압박 해소, 칼 같은 전진 패스, 화려하면서도 효과적인 턴 스킬 등의 퍼포먼스, 높은 득점 능력을 모두 필요로 하는만큼 상당히 지능적으로 움직여야 해요. 이 모든 것들을 소화하려면 기술적으로도 훌륭한 수준 이어야겠죠? 마치 그라운드 위의 골 기획자인 것이죠 :)',
                        '뇌지컬만큼이나 피지컬도 뛰어난 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 세컨드 스트라이커입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_ss_데니스 베르캄프.png'),
                        require('@/assets/myposition_ss_라울 곤살레스.png'),
                        require('@/assets/myposition_ss_알레산드로 델피에로.png'),
                        require('@/assets/myposition_ss_웨인 루니.png'),
                    ],
                    names: [
                        '데니스 베르캄프', '라울 곤살레스', '알레산드로 델피에로', '웨인 루니'
                    ]
                },
                WF: {
                    explanation: [
                        '윙 포워드',
                        'WING FOWARD',
                        '윙 포워드 (WF)',
                        '만약 축구에 마술이 존재한다면 그것은 모든 상황에<br>대비하기 위한 많은 훈련과 노력에서 나오는 것이다.',
                        '호나우지뉴',
                        '저돌적이고 빠른 돌파와 폭발적인 기량',
                        '빠르고 재치있는 퍼포먼스를 선보이고 공간을 휘젓고 다니면서 공격에 직접 가담하는 윙 포워드 (WF)는 빠른 스피드로 공격의 흐름을 바꿀 수 있는 역할을 해요.',
                        '현대 축구에서 윙 포워드는 저돌적으로 돌파하여 공격 찬스를 만들어내는 역할을 하는만큼 드리블면에서 기술적으로 매우 뛰어나야하며, 대체로 발 동작이 빠르거나 스피드가 빠른 선 수들이 윙 포워드 포지션에서 뛰곤 해요. 중앙으로 침투해 득점을 올려야 하는 경우도 있어 득점 능력도 상당히 우수해야 하고 체력적으로도 뛰어나야 하는 포지션이죠.',
                        '축구에서 가장 드라마틱한 포지션이라고 생각하셔도 돼요. 치고 달리면서 빠르게 올라와 중앙까지 침투, 수비수를 앞두고 한 번 접은 뒤 바로 슛. 그리고 골. 가장 축구다운 장면이 만들어지는 거죠. 물론 그만큼 개인기량이 좋아야겠지만요.',
                        '벽을 뚫는 날개짓',
                        '일반적으로 윙어는 자신이 뛰는 위치와 사용하는 발을 같이 하곤 했는데, 최근에는 사용하는 발로 슈팅을 때리기 위해 반대 측면에서 뛰는 인버티드 윙어도 전략적으로 늘어나고 있어요!',
                        '빠르고 강한 움직임으로 상대 진영을 저돌적으로 파고드는 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 세컨드 스트라이커입니다 :)',
                    ],
                    images: [
                        require('@/assets/myposition_wf_리오넬 메시.png'),
                        require('@/assets/myposition_wf_손흥민.png'),
                        require('@/assets/myposition_wf_크리스티아누 호날두.png'),
                        require('@/assets/myposition_wf_킬리안 음바페.png'),
                    ],
                    names: [
                        '리오넬 메시', '손흥민', '크리스티아누 호날두', '킬리안 음바페'
                    ]
                },
                AM: {
                    explanation: [
                        '공격형 미드필더',
                        'ATTACKING MIDFIELDER',
                        '공격형 미드필더 (AM)',
                        '축구는 테니스가 아니다.<br>때로는 터프한 플레이가 필요하다.',
                        '거스 히딩크',
                        '압도적인 기량의 플레이메이커',
                        '과감하고 도전적이며 능수능란하게 공격의 판을 만들어내는 이름하여 ‘공격 기획자’ 공격형 미드필더 (AM)는 뛰어난 드리블 기술로 수비 압박을 이겨낸 후에 공격수에게 공을 정확하게 연결해주는 역할을 하죠.',
                        '현대 축구에서 공격형 미드필더는 상대의 수비 전략이 펼쳐 지는 가운데서 치열한 압박을 뚫고 공격을 연계해야 하기에 드리블 능력, 패스 전달 능력과 킥력이 전체적으로 좋아야 해요. 또 상대 수비 진영을 교묘하게 파고 들어야 하기에 위치선정 능력 또한 좋아야 하죠. 또한 압박의 강도가 점점 거세지는 현대 축구의 특성상 체력, 피지컬적으로도 많은 요구사항이 생겼어요!',
                        '레고를 가지고 놀듯’ 플레이를 한다고 생각해볼까요? 기가 막히게 수비진영을 해체하고, 공격로를 조립하여 창의적으로 골을 만들어주고 승리를 이끌어 내는 거죠! 혹은 직접 슛을 하여 골을 만들어낼 수도 있는 정말 매력적이고 ‘축구 재밌게 하는’ 포지션인 거예요.',
                        '안되는 것도 되게 한다!',
                        '매우 감각적인 움직임으로 공격을 컨트롤하는 포지션의 특성상 굉장히 창의적이고 센스티브한 패스 플레이를 종종 목격할 수 있어요. 불가능한 건 없어요. 우리팀 공격수들이 집중 마크를 당하고 있을 때도 직접 파고들거나 말도 안되는 크로스를 올려주면서 심플하게 마무리를 지을 수 있으니까요!<br>축구를 참 쉽게 할 수 있고, 팀의 중추가 되는 플레이메이커인 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 공격형 미드필더입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_am_이강인.png'),
                        require('@/assets/myposition_am_지네딘 지단.png'),
                        require('@/assets/myposition_am_카카.png'),
                        require('@/assets/myposition_am_케빈 더 브라위너.png'),
                    ],
                    names: [
                        '이강인', '지네딘 지단', '카카', '케빈 더 브라위너'
                    ]
                },
                CM: {
                    explanation: [
                        '중앙 미드필더',
                        'CENTER MIDFIELDER',
                        '중앙 미드필더 (CM)',
                        '다른 것은 없다. 오직 축구공이다.<br>축구공을 위해 온 몸을 희생한다',
                        '크리스찬 비에리',
                        "‘공이 필요해? 지금 그라운드 어디든, 총알 배송!’",
                        '그라운드의 가장 중앙, 전략적인 요충지에서 주로 활약하며, 팀의 공,수 전략의 핵심을 담당하는 중앙 미드필더 (CM)는 중앙에서 공격, 수비에 가담하여 공을 점유하고 전달하는 핵심적인 역할을 하죠.',
                        '현대 축구에서 중앙 미드필더는 중앙에서 공을 전달해주어야 하기에 볼 배급 능력이 매우 중요하며, 중앙에서 거센 압박을 이겨내면서 공을 지켜야 되기 때문에 가장 활발하게 움직여야 해요. 즉, 체력도 좋아야 하고, 기술적인 부분도 좋아야 하죠. 또한 어느 쪽에든 공을 원활하게 전달해야 하기에 도전적이라기 보다는 안정적으로 패스를 잘 주는 게 중요한 포지션이예요.',
                        '심장은 몸 전체에 피를 전달해요. 중앙 미드필더는 그라운드의 심장인셈이죠. 어디에든 안정적으로 공을 전달할 수 있는 팀의 전략적인 코어인 거예요. 수비시에는 수비 가담도 하고, 공격시에는 공격 포인트를 만들어주는 ‘커멘드 센터’ 같은 포지션이죠!',
                        '전천후 서포터',
                        '홀딩 미드필더보다 높은 위치에서 뛰어난 체력과 활동량을 바탕으로 공,수를 오가며 다양한 역할을 수행하는 전천후 플레이어인 박스 투 박스(box to box) 미드필더는 공을 배송해주는 역할도 물론 수행하지만 여러 상황에서 팀을 도와주고 공을 받아주는 든든한 서포터 역할을 하기도 해요. 다방면으로 뛰어난 기량을 가지고 있는 만능 플레이어인 거죠. <br>그러나 전술의 발전으로 점점 보기 드물어지는 역할이기도 해요.',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_cm_루카 모드리치.png'),
                        require('@/assets/myposition_cm_안드레스 이니에스타.png'),
                        require('@/assets/myposition_cm_차비 에르난데스.png'),
                        require('@/assets/myposition_cm_토니 크로스.png'),
                    ],
                    names: [
                        '루카 모드리치', '안드레스 이니에스타', '차비 에르난데스', '토니 크로스'
                    ]
                },
                WM: {
                    explanation: [
                        '측면 미드필더',
                        'WIDE MIDFIELDER',
                        '측면 미드필더 (WM)',
                        '뛰어난 킥은 하루만에 만들어지지 않는다.<br>수천 수만 번의 노력으로 탄생하는 것이다.',
                        '데이비드 베컴',
                        '바람같은 움직임',
                        '헌신적이고, 빠른 움직임과 정확한 크로스 능력을 갖추고, 수비시엔 측면에서 압박을 가하는 측면 미드필더 (LM,RM)는 측면에서 중앙으로의 볼 배급과 동시에 상대의 볼 배급을 막아주는 역할을 해요.',
                        '현대 축구에서 윙 포워드와 측면 미드필더의 경계가 점점 모호해지는 추세이지만, 여전히 점유율 혹은 공수 밸런스를 촘촘하게 유지하는 전술에서는 다양하게 기용되죠. 주 활동 범위는 측면이지만, 활동량이 많기에 높은 체력이 요구되며, 킥력과 개인기량이 높아야 해요.',
                        '축구장 측면에서 시원한 바람처럼 움직이죠. 복잡한 빌드업이 필요한가요? 중원에서부터 압박을 이겨내고 빠르게 돌파해 골문 앞까지 얼리크로스를 올려주세요! 골까지 다이렉트로 연결해주는 거예요.',
                        '“심최몇?” 심장 최소 여러 개.',
                        '상황에 따라 오버랩핑을 해가며, 공격과 수비 양쪽을 적극적으로 가담하는 역할을 하기에 체력적으로 굉장히 뛰어나며, 놀라운 활동량을 자랑해요. 잔잔한 바람이 아닌 강철 바람인 거죠. 지치지 않는 체력으로 그라운드에 바람을 일으키는 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 측면 미드필더 (LM,RM)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_wm_다비드 실바.png'),
                        require('@/assets/myposition_wm_데이비드 베컴.png'),
                        require('@/assets/myposition_wm_루이스 피구.png'),
                        require('@/assets/myposition_wm_박지성.png'),
                    ],
                    names: [
                        '다비드 실바', '데이비드 베컴', '루이스 피구', '박지성'
                    ]
                },
                DM: {
                    explanation: [
                        '수비형 미드필더',
                        'DEFENSIVE MIDFIELDER',
                        '수비형 미드필더 (DM)',
                        '공을 소유하는 것이 곧 수비이다. 우리가 공을 갖고<br>있을 때, 상대 팀은 공격을 할 수 없기 때문이다.',
                        '펩 과르디올라',
                        '그라운드 중앙에 세워진 높은 벽',
                        '중앙 최후방에서 공을 캐치하고, 볼을 직접적으로 연결해 경기 흐름을 순식간에 바꿀 수 있는 수비형 미드필더 (DM)은 위협적인 공격력을 가진 공격수에 압박을 가해 저지하고, 직접적으로 볼을 배급하고, 빌드업을 해나가는 역할을 해요.',
                        '현대 축구에서는 전술적으로 전방 압박을 중요시하기에 상대적으로 최후방에 있는 수비형 미드필더가 볼을 직접 배급하는 역할이 커졌어요. 대인 방어, 지역 방어와 더불어 공격 흐름을 만들기 위한 패스 능력이 뛰어나야 하기에 수비형 미드필더라는 역할은 굉장히 전문적이며, 지능적이기에 누구나 할 수 있는 쉬운 포지션은 아니죠.',
                        '가운데 세워진 벽이 공격수를 자유롭게 따라다녀요. 무서운 벽이죠. 공이 오는 것들을 모두 잘라내고 볼을 가지고 난 후부터 바로 공격이 시작되는 거예요. 수비적인 역할만 할 거라고 생각하면 안돼요. 어쩌면 현대축구에서 가장 무서운 포지션이죠.',
                        "보이지 않는 ‘발’",
                        '수비형 미드필더는 지능적인 움직임과 전술 이해도를 바탕으로 움직이는 역할인만큼 팀에서 가장 중요하고, 가장 티 안 나게 위협적인 포지션이예요. 빠르지 않고, 퍼포먼스가 부족하다고 해서 없어도 될 포지션은 아닌 거죠. 그라운드의 진정한 ‘숨은 고수’ ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 수비형 미드필더 (DM)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_dm_세르히오 부스케츠.png'),
                        require('@/assets/myposition_dm_안드레아 피를로.png'),
                        require('@/assets/myposition_dm_은골로 캉테.png'),
                        require('@/assets/myposition_dm_카세미루.png'),
                    ],
                    names: [
                        '세르히오 부스케츠', '안드레아 피를로', '은골로 캉테', '카세미루'
                    ]
                },
                WB: {
                    explanation: [
                        '윙백',
                        'WING BACK',
                        '윙백 (WB)',
                        '최고의 공격은<br>최고의 수비다.',
                        '호베르트 카를로스',
                        '제트엔진이 달린 강철 날개',
                        '뛰어난 체력과 지구력, 스피드를 바탕으로 공격적인 플레이를 전개하는 윙백 (LWB,RWB)은 윙 포워드, 측면 미드필더에 준하는 퍼포먼스와 활동량을 자랑하며, 측면에서 빠르고 직접적인 공격 전개를 이끌어 나가는 역할을 해요.',
                        '풀백과 비슷한 점이 있지만, 전술적으로 활동하는 위치와 역할이 다르므로, 두 포지션이 완전히 같다고는 할 수 없죠. 미드필더 위치 (2선)까지 올라와 활동하기 때문에 공격을 전개하는 것이 주된 목표인 역할이예요. 그만큼 빠른 스피드와 퍼포먼스가 요구되며 킥력, 마무리 능력도 좋아야 하죠.',
                        '비행기 날개처럼 튼튼하고 빠르게 움직여요. 상황에 따라서는 폭격을 하듯 공을 차거나, 상대 수비와의 도그 파이트에서도 지지 않는 개인기량과 퍼포먼스를 보여줘요. 사실상 수비수라는 생각보다는 또 하나의 공격수라는, ‘숨어 있는 스텔스기’라는 생각을 해야 하죠.',
                        '가짜 윙백',
                        '현대축구에서 ‘폴스 윙/풀백’이 주요 공격 자원으로 활용되는데, 윙백, 풀백의 위치상의 역할을 파괴해 측면에서 전방 안쪽까지 침투해 공격 빌드업에 가담하여 플레이를 만드는 역할을 하죠. 빠른 움직임으로 단숨에 골키퍼 코 앞까지 치고 나가는 퍼포먼스와 기량을 갖춘 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 윙백 (LWB,RWB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_wb_마르셀루.png'),
                        require('@/assets/myposition_wb_마르코스 알론소.png'),
                        require('@/assets/myposition_wb_이반 페리시치.png'),
                        require('@/assets/myposition_wb_호베르트 카를로스.png'),
                    ],
                    names: [
                        '마르셀루', '마르코스 알론소', '이반 페리시치', '호베르트 카를로스'
                    ]
                },
                FB: {
                    explanation: [
                        '풀백',
                        'FULL BACK',
                        '풀백 (FB)',
                        '풀백으로 뛰면서 그는 왼쪽 측면을<br>아예 자기 소유로 만들어 버리곤 했다.',
                        '필리포 갈리',
                        '측면의 수호자',
                        '윙백과 마찬가지로 빠른 스피드와, 체력을 바탕으로 측면에서 윙어를 전담하여 저지하는 풀백 (LB,RB)은 윙백보다는 좀 더 수비적인 위치에서 중앙 수비수를 지원하고, 측면 공격 전개를 집중적으로 막아내는 역할을 해요.',
                        '공격시에는 전방으로 올라가 공격에도 가담하고 다시 수비진영 까지 빠르게 내려올 수 있어야 하기에, 빠른 스피드와 좋은 체력 혹은 피지컬이 요구되죠. 주로 측면을 수호하는 역할을 하기에 수비적인 기술 (태클, 압박, 대인 방어 등)이 요구되며, 현대 축구에서는 상황에 따라 좋은 킥력과 돌파력도 겸비해야 하는 상당히 중요한 자원이죠.',
                        '영화에서나 볼법한 숨막히는 추격씬을 보는 것 같죠. 상대팀에서 가장 발이 빠른 사람을 막으러 다녀야 하니까요 상황에 따라서는 직접 공을 운반하기도 해요. 굉장한 퍼포먼스를 보여주며, 공격에 가담하는 거죠. 측면을 수호하면서 공격을 돕는 아주 좋은 서포터예요.',
                        "현대축구에서 가장 중요한 것은 ‘풀백’이다.",
                        '사실 대부분의 선수가 기피하고 다른 포지션에 비해 실력이 아주 뛰어진 않는 선수가 가야하는 비운의 위치이지만, 오히려 월드클래스로서 빛날 수 있는 희소성을 가진 포지션이죠. 그렇기 때문에 최근들어 공격 성향을 탑재한 풀백을 전술적으로 이용하는 추세죠. 수비적이며, 빠른 판단과 행동력을 갖춘 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 풀백 (LB,RB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_fb_주앙 칸셀루.png'),
                        require('@/assets/myposition_fb_카푸.png'),
                        require('@/assets/myposition_fb_트렌트 알렉산더-아놀드.png'),
                        require('@/assets/myposition_fb_파울로 말디니.png'),
                    ],
                    names: [
                        '주앙 칸셀루', '카푸', '트렌트 알렉산더-아놀드', '파울로 말디니'
                    ]
                },
                CB: {
                    explanation: [
                        '센터백',
                        'CENTER BACK',
                        '센터백 (CB)',
                        '반 다이크는 자신의 타이밍을 판단하고 적절한 순간을<br>기다리며 공격수에게 도전할 줄 아는 수비수이다.',
                        '리오넬 메시',
                        '헌신적인 방패',
                        '큰 키와 누구와도 지지 않을만큼 강하고 튼튼한 신체, 좋은 시야와 발 밑 기술을 토대로 고도의 집중력을 발휘하는 센터백 (CB)은 페널티 라인 밖에서 공과 선수를 차단하고, 수비 상황을 조율하며 세트피스 상황시 큰 키를 활용해 득점을 올리기도 하는 등의 역할을 해요.',
                        '전방 압박이 주요 전술 트렌드인 현대 축구에서 발 기술 또한 중요해졌으며, 조금이라도 방심을 하면 안되는 상황에 이르렀죠. 좋은 체격에 걸맞게 도전적으로 방어하는 역할을 하기에 높은 수준의 수비 능력 (태클, 압박, 대인 방어 등)이 요구되며, 상황에 따라 단순히 걷어내는 게 아닌 공격까지 전개될 수 있도록 정확한 킥 능력 또한 요구되죠.',
                        '패널티 라인 밖을 무섭도록 정교하게 수호하고 있어요. 초집중 상태에서 발을 들이밀고, 몸을 저돌적으로 붙이죠. 맞서 싸우거나 도망가거나 둘 중 하나를 선택하면 되지만, 도망갈 수밖에 없어요. 누구나 그럴 거죠. 까마득히 커다란 거인들이 길을 막고 서있으니까요.',
                        '세트피스 상황의 주인공',
                        '큰 체격을 가진 센터백은 세트피스 상황에서 높은 제공권을 가지고 있어요. 따라서 볼을 걷어내거나, 골을 넣는 역할에 특화되어 있죠. 어느 순간에서나 고도의 집중력을 발휘해야 되는 포지션인만큼 난이도가 굉장히 높은 포지션이예요. 우월한 체격 조건과 도전적인 ' + this.$GlobalStore.loginInfo().name + ' 회원님, 당신은 센터백 (CB)입니다 :)',
                        '',
                    ],
                    images: [
                        require('@/assets/myposition_cb_김민재.png'),
                        require('@/assets/myposition_cb_버질 반 다이크.png'),
                        require('@/assets/myposition_cb_세르히오 라모스.png'),
                        require('@/assets/myposition_cb_파비오 칸나바로.png'),
                    ],
                    names: [
                        '김민재', '버질 반 다이크', '세르히오 라모스', '파비오 칸나바로'
                    ]
                },
                GK: {
                    explanation: [
                        '골키퍼',
                        'GOAL KEEPER',
                        '골키퍼 (GK)',
                    ],
                    images: [],
                    names: []
                }

            },
            // showPosition: false,
            isShowCopyPicture: false,
            copy_picture_left: 0,
            copy_picture_top: 0,
            prev_copy_picture_left: 0,
            prev_copy_picture_top: 0,
            picture_top_gap: 70,
            copy_picture_big_size: 220,
            copy_picture_small_size: 160,
            copy_picture_width: 160,
            isShowPositions: false,
            isShowPositionPictures: true,
            curSelectedPictureIndex: -1,
            copy_picture_scale_x: 1,
            positionPictureOpacity: 1,
            oneResult: false,
        }
    },
    watch: {
        signalCloseDetail() {
            this.isShowPositionPictures = true;
            this.copy_picture_scale_x = 1;
            setTimeout(() => {
                this.isShowCopyPicture = false;
                this.curSelectedPictureIndex = -1;
            }, 1000);

            setTimeout(() => {
                this.positionPictureOpacity = 1;
            }, 10)

            this.copy_picture_width = this.copy_picture_small_size;
            this.copy_picture_left = this.prev_copy_picture_left;
            this.copy_picture_top = this.prev_copy_picture_top;
        }
    },
    methods: {
        async share() {
            const message = '';
            const res = await this.$Axios.get('/api/share/position/url');
            const url = res.data.url;

            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        closeProModal() {
            this.isShowProModal = false
        },
        retryFindPosition() {
            this.$GlobalStore.closeModalAll()
            this.$GlobalStore.addModal('FindPositionStart', { start: true })
        },
        findPositionPro() {
            if (this.initPosition) return;
            const [is_complete] = this.$Util.checkIsProfileComplete();
            if (is_complete) {
                this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">포지션 결과 저장</strong><br>포지션 찾기 결과를 저장하지 않으셨습니다.<br>포지션을 저장하고 이동하시겠습니까?', () => {
                    this.goPositionPro()
                }, '저장하기', '저장하지 않기', this.$GlobalStore.CONFIRM_TYPE.VERSION2, false, null, 320)
            } else {
                this.$GlobalStore.showToastVer2('일단 프로필 작성을 완료해주세요.', TOAST_TYPE.AMEND)
            }
        },
        goPositionPro() {
            this.confirmProfilePosition(true)
        },
        showPositionResult(desc, i, img_path) {
            this.curSelectedPictureIndex = i;
            this.isShowCopyPicture = true;
            this.positionPictureOpacity = 0;
            setTimeout(() => {
                this.isShowPositionPictures = false;
            }, 1000);

            const rect = this.$refs.images[i].getBoundingClientRect();

            this.copy_picture_left = rect.left;
            this.copy_picture_top = rect.top;

            this.prev_copy_picture_left = rect.left;
            this.prev_copy_picture_top = rect.top;

            this.copy_picture_width = this.copy_picture_small_size;

            setTimeout(() => {
                this.copy_picture_scale_x = -1;
                this.copy_picture_width = this.copy_picture_big_size;
                this.copy_picture_top = this.picture_top_gap + 30;
                this.copy_picture_left = window.screen.width / 2 - this.copy_picture_big_size / 2
            }, 10)

            // if (this.showPosition) {
            //     return
            // }
            // this.$refs.images.forEach(item => {
            //     console.log(item.getBoundingClientRect())
            //     if (parseInt(item.dataset.num) !== i) {
            //         // this.left = rect.left + 'px'
            //         item.style.opacity = 0
            //     } else {
            //         item.style.top = 0
            //         // this.$refs.fake_img.style.display = 'block'
            //     }
            // })
            // this.$refs.fake_img.style.left = this.left
            this.img_path = img_path;
            this.position = desc;
            this.showResult(this.left, i)
        },
        showPositionResultOneResult(desc, i, img_path) {
            if (this.oneResult) {
                this.curSelectedPictureIndex = i;
                this.isShowCopyPicture = true;
                this.positionPictureOpacity = 0;
                setTimeout(() => {
                    this.isShowPositionPictures = false;
                }, 1000);

                const rect = this.$refs.images[i].getBoundingClientRect();

                this.copy_picture_left = rect.left;
                this.copy_picture_top = rect.top;

                this.prev_copy_picture_left = rect.left;
                this.prev_copy_picture_top = rect.top;

                this.copy_picture_width = this.copy_picture_small_size;

                setTimeout(() => {
                    this.copy_picture_scale_x = -1;
                    this.copy_picture_width = this.copy_picture_big_size;
                    this.copy_picture_top = this.picture_top_gap + 30;
                    this.copy_picture_left = window.screen.width / 2 - this.copy_picture_big_size / 2
                }, 10)
                this.img_path = img_path;
                this.position = desc;
                this.showResult(this.left, i)
            } else {
                return
            }

        },
    },
    created() {
        if (this.initPosition) {
            this.position = this.initPosition;
            this.img_path = this.result[this.initPosition].images[0];
        }
        if (this.showExplanation) {
            switch (this.positionsArr.position) {
                case 'LWF':
                case 'RWF':
                    this.position = 'WF'
                    break;
                case 'LM':
                case 'RM':
                    this.position = 'WM'
                    break;
                case 'LWB':
                case 'RWB':
                    this.position = "WB"
                    break;
                case "LB":
                case "RB":
                    this.position = "FB"
                    break;
                default: this.position = this.positionsArr.position
            }

            this.img_path = this.result[this.position].images[0]
        }
        if (this.positionsArr.length === 1) {
            this.oneResult = true
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.test-enter-active {
    animation: bounce-in .5s;
}

.test-leave-active {
    animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
    0% {
        left: 0%;
        top: 1px;
    }

    50% {
        left: 25%;
        top: 60px;
    }

    100% {
        left: 50%;
        top: 124px;
    }
}

.subTitle {
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 16px;
}

.explanation {
    font-size: 14px;
    line-height: 23px;
    font-weight: 400;
}

.player_name {
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    margin-top: 16px;
}

.show_position {
    width: 251px;
    margin: 0 auto;
    height: 70px;
    line-height: 70px;
    color: #fff;
    border-radius: 43px;
    background-color: #210f03;
    text-align: center;
    margin-bottom: 50px;
}

.shared {
    width: 170px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 6px;
    background-color: #210f03;
    text-align: center;
    font-size: 14px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    display: flex;
    align-items: center;
    justify-content: center;
}

.one_result {
    max-width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 28px;
}

.else_result {
    max-width: 100%;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 39px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    padding: 0px 20px;
}

.many_image {
    /* justify-content: center; */
    padding-left: 35px;
    padding-right: 35px;
    gap: 12px;
    /*margin-bottom: 79px;*/
    /*margin-top: 59px;*/
    display: flex;
}

.one_image {
    text-align: center;
    margin-bottom: 48px;
    display: flex;
    justify-content: center;
}
</style>